// src/components/BottomNav.jsx — v2
// CHANGED FROM v1 (17 Jul 2026, P34/P40): added Wallet as a 6th nav
// item (Home, Shop, Wallet, Wishlist, Cart, Account) — gives one-tap
// access to the Cashback Statement from anywhere, matching Amazon's
// precedent for a 6-icon bottom nav. Routes to the existing
// /account/wallet-statement page, no new page needed. No badge count
// on this icon (unlike Cart/Wishlist) — wallet balance doesn't have a
// natural "unread count" the way cart items or wishlist saves do.
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStore } from '../context/StoreContext';
const NAV_ITEMS = [
  { path: '/', icon: 'ti-home', label: 'Home' },
  { path: '/shop', icon: 'ti-layout-grid', label: 'Shop' },
  { path: '/account/wallet-statement', icon: 'ti-wallet', label: 'Wallet' },
  { path: '/wishlist', icon: 'ti-heart', label: 'Wishlist' },
  { path: '/cart', icon: 'ti-shopping-bag', label: 'Cart' },
  { path: '/account', icon: 'ti-user', label: 'Account' },
];
export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { cartCount, wishlist } = useStore();
  return (
    <nav className="bottom-nav" aria-label="Main navigation">
      {NAV_ITEMS.map(item => (
        <button
          key={item.path}
          className={`bnav-item ${location.pathname === item.path ? 'active' : ''}`}
          onClick={() => navigate(item.path)}
          aria-label={item.label}
        >
          <div style={{ position: 'relative', display: 'inline-flex' }}>
            <i className={`ti ${item.icon}`} aria-hidden="true"></i>
            {item.path === '/cart' && cartCount > 0 && (
              <span style={{
                position: 'absolute', top: -6, right: -8,
                background: 'var(--blue)', color: '#fff',
                fontSize: 8, width: 14, height: 14,
                borderRadius: '50%', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                fontWeight: 500
              }}>{cartCount}</span>
            )}
            {item.path === '/wishlist' && wishlist.length > 0 && (
              <span style={{
                position: 'absolute', top: -6, right: -8,
                background: '#E24B4A', color: '#fff',
                fontSize: 8, width: 14, height: 14,
                borderRadius: '50%', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                fontWeight: 500
              }}>{wishlist.length}</span>
            )}
          </div>
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
